import React from "react";
import {
  ContentContainer,
  ContentRow,
  ContentTitle,
  ContentDescription,
  ContentAmount,
  ContentWrapper,
  ContentWrapperTitle,
} from "./pricingsection.styles";
import { IoCheckmarkOutline } from "react-icons/io5";

const index = () => {
  const contentData = [
    {
      title: "Payments",
      description:
        "Lorem ipsum dolor sit amet consectetur. Eget viverra nunc sapien tortor ortor.",
      amount: "$0.00",
    },
    {
      title: "Invoicing",
      description:
        "Lorem ipsum dolor sit amet consectetur. Eget viverra nunc sapien tortor ortor.",
      amount: "$0.00",
    },
    {
      title: "Payment Link",
      description:
        "Lorem ipsum dolor sit amet consectetur. Eget viverra nunc sapien tortor ortor.",
      amount: "$0.00",
    },
    {
      title: "Billing",
      description:
        "Lorem ipsum dolor sit amet consectetur. Eget viverra nunc sapien tortor ortor.",
      amount: "$0.00",
    },
    {
      title: "Check out",
      description:
        "Lorem ipsum dolor sit amet consectetur. Eget viverra nunc sapien tortor ortor.",
      amount: "$0.00",
    },
  ];

  return (
    <ContentContainer>
      {contentData.map((item, index) => (
        <ContentRow key={index}>
          <ContentWrapperTitle>
            <ContentTitle>{item.title}</ContentTitle>
          </ContentWrapperTitle>

          <ContentWrapper>
            <div>
              {[...Array(3)].map((_, i) => (
                <ContentDescription key={i}>
                  <span>
                    <IoCheckmarkOutline />
                  </span>{" "}
                  {item.description}
                </ContentDescription>
              ))}
            </div>
            <div>
              {[...Array(3)].map((_, i) => (
                <ContentAmount key={i}>{item.amount}</ContentAmount>
              ))}
            </div>
          </ContentWrapper>
        </ContentRow>
      ))}
    </ContentContainer>
  );
};

export default index;
